/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable, makeEnvironmentProviders } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  CategoriesItemType,
  InitMenutType,
  MainNavigationChildType,
  MainNavigationItemType,
  PopularKeywords,
  ProductRecommendationItemType
} from '@shared/component.header';
import { filter, map, Observable, switchMap } from 'rxjs';
import { environment } from '@environments/environment';
import { HeaderRepository } from '../../../@core/repositories/header.repository';
import { HttpService } from '@shared/services/http/http.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderAdapter extends HeaderRepository {
  http = inject(HttpService);
  url = environment.drupalApi;

  getMenuheader(isEnglish: boolean): Observable<InitMenutType> {
    const START_INDEX = 0;
    let targetUrl = `${this.url}/header_rest?format=json`;

    if (isEnglish) {
      targetUrl = `${this.url}/en/header_rest?format=json`;
    }
    return this.http.get(targetUrl, {}, [{key: 'authorization', value: 'Basic ' + btoa('softengine:D194Nt!DuLu4j4')}]).pipe(
      map((res: any) => res.data[START_INDEX].item),
      map((res: any) => {
        return {
          topLeftnavigation: res.top_left_navigation.map((item: any) => ({
            title: item.title,
            link: item.link,
            isActive: item.is_active
          })),
          topRightNavigation: res.top_right_navigation.map((item: any) => ({
            title: item.title,
            link: item.link
          })),
          loginUrl: '/login',
          mainNavigation: res.personal_menu.map(
            (item: any): MainNavigationItemType => ({
              title: item.title,
              isActive: false,
              children: item.child_menu.map(
                (child: any): MainNavigationChildType => ({
                  title: child.title,
                  link: child.link
                })
              )
            })
          ),
          dropdownMenu: {
            categories: res.category_recommendation.map(
              (item: any): CategoriesItemType => ({
                link: item.link,
                imageSrc: item.icon_url,
                alt: item.name
              })
            ),
            popularKeywords: res.popular_keywords.map(
              (item: any): PopularKeywords => ({
                title: item.name,
                link: item.link
              })
            ),
            productRecommendation: res.product_recommendation.map(
              (item: any): ProductRecommendationItemType => ({
                imageSrc: item.image_url,
                link: item.link,
                alt: item.name
              })
            )
          }
        };
      })
    );
  }
  getLogoPaths(router: Router): Observable<{ logoUrl: string }> {
    return router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      switchMap((event: NavigationEnd) =>
        this.http.get<{ data: any[] }>(`${this.url}api/paths-header-logo`, {}).pipe(
          map(({ data }) => {
            let pathLength = 0;

            data.forEach((item: any) => {
              if (item.path.endsWith('/*')) {
                item.path = item.path.replace('/*', '');
              }

              if (item.path.endsWith('/')) {
                item.path = item.path.replace('/', '');
              }

              if (
                item.path.includes(event.url) &&
                item.path.length > pathLength
              ) {
                pathLength = item.path.length;
              }
            });

            data.forEach((item: any) => {
              item['match'] = false;

              if (
                item.path.includes(event.url) &&
                item.path.length === pathLength
              ) {
                item['match'] = true;
              }
            });

            return { logoUrl: data.find((item: any) => item['match'])?.logo };
          })
        )
      )
    );
  }
}

export const provideHeaderService = () =>
  makeEnvironmentProviders([
    {
      provide: HeaderRepository,
      useClass: HeaderAdapter
    }
  ]);
